import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, input, InputSignal, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InterestList } from '../../../../interfaces/edit-route.response';
import { TranslationService } from 'src/app/services';

interface InterestListChip {
  id: number;
  label: string;
  value: number;
}

@Component({
  selector: 'interest-filter',
  standalone: true,
  imports: [
    TranslateModule,
  ],
  templateUrl: './interest-filter.component.html',
  styleUrls: ['./interest-filter.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InterestFilterComponent {
  // Output signals
  public interestsIdsChange = output<number[]>();
  
  // Input signals
  public interestList: InputSignal<InterestList[]> = input.required<InterestList[]>();

  // Service injections
  private _translationService = inject(TranslationService);
  
  // State service signals
  private _selectedLanguage = this._translationService.selectedLanguage

  // Computed signals
  protected interestListChip = computed<InterestListChip[]>(() => {
    const interests = this.interestList();
    return interests.map(interest => ({
      id: interest.id,
      label: interest.name?.[this._selectedLanguage()] || '',
      value: interest.id
    }));
  });

  // Methods
  handleSelectedInterest(event: Event){
    const customEvent = event as CustomEvent<{ values: number[] }>;
    const selectedInterestList = customEvent.detail.values; 
    
    this.interestsIdsChange.emit(selectedInterestList);
  }
}